import { createPrefixedActions } from '@zapier/toolbox-redux-framework';

export default createPrefixedActions(
  'perf',
  `
  RECORD_TIME_TO_MOUNT
  `
);
